import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { Stack, Button, Container, Typography } from '@mui/material';

import Iconify from '../components/iconify';

export default function OnboardingLockedPage({ companyId }) {
  const navigate = useNavigate();
  return <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
    <Stack spacing={2.5} alignItems="center" textAlign="center">
      <Iconify icon="solar:lock-keyhole-minimalistic-bold-duotone" width={56} sx={{ color: 'text.disabled' }} />
      <Typography variant="h5" component="h1">Sezione non ancora attiva</Typography>
      <Typography color="text.secondary">Disponibile al termine dell’onboarding: lo Studio ti avviserà quando l’azienda sarà attiva.</Typography>
      <Button variant="contained" onClick={() => navigate(`/onboarding/${companyId}`)}>Vai all’onboarding</Button>
    </Stack>
  </Container>;
}
OnboardingLockedPage.propTypes = { companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired };
